<template>
  <div>
    <v-switch
      v-model="enabled"
      label="textHint"
      dense
      hide-details
      @change="toggleTextHint"
      class="mb-2"
    />

    <devContainerOfPanel
      v-if="enabled"
      :schema="{
        type: 'devContainerOfPanel',
        model: 'textHint',
        component: 'dev-simple-object-attr',
        styleClasses: 'col-12',
        title: 'text Hint'
      }"
      :model="{ textHint: model.textHint }"
    />
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';

import eventBus from 'vue-option-events';
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  mixins: [abstractField],

  components: {
    devContainerOfPanel: () => import('@/components/dev/dev-container-of-panel')
  },

  data: () => ({
    enabled: false,
    textHint: {
      class: '',
      text: 'Lorem Ipsum!'
    }
  }),

  mounted() {
    'textHint' in this.model && (this.enabled = true);
  },

  methods: {
    toggleTextHint(e) {
      if (e) this.model.textHint = this.textHint;

      if (!e) delete this.model.textHint;

      eventBus.$emit(HANDLERS.RELOAD_COMPONENT_DEV);
    }
  }
};
</script>

